 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"BondPage":"BondPage","BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610":"BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610","BondPageID":"BondPageID","CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage":"CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage","PoolInvestPage~PoolPage~PortfolioPage":"PoolInvestPage~PoolPage~PortfolioPage","PoolInvestPage~PoolWithdrawPage":"PoolInvestPage~PoolWithdrawPage","PoolInvestPage":"PoolInvestPage","PoolPage~PoolWithdrawPage":"PoolPage~PoolWithdrawPage","PoolWithdrawPage":"PoolWithdrawPage","HomePage~PortfolioPage":"HomePage~PortfolioPage","HomePage":"HomePage","PortfolioPage":"PortfolioPage","PoolPage":"PoolPage","SingleStakePage":"SingleStakePage","SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector":"SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector","SunrisePage~TradePage~WalletConnectConnector":"SunrisePage~TradePage~WalletConnectConnector","SunrisePage~TradePage":"SunrisePage~TradePage","SunrisePage":"SunrisePage","VexPolarPage":"VexPolarPage","ClaimPage":"ClaimPage","CookiesPolicyPage":"CookiesPolicyPage","CreatePoolPage":"CreatePoolPage","GetVeBalPage":"GetVeBalPage","TradePage":"TradePage","FaucetPage":"FaucetPage","GnosisSafeConnector":"GnosisSafeConnector","MigratePoolPage":"MigratePoolPage","PrivacyPolicyPage":"PrivacyPolicyPage","WalletConnectConnector~WalletLinkConnector":"WalletConnectConnector~WalletLinkConnector","WalletConnectConnector":"WalletConnectConnector","WalletLinkConnector":"WalletLinkConnector","SunrisesPage":"SunrisesPage","TallyConnector":"TallyConnector","TermsOfUsePage":"TermsOfUsePage","UnlockVeBalPage":"UnlockVeBalPage","VeBalPage":"VeBalPage"}[chunkId]||chunkId) + "." + {"BondPage":"ed7dc871","BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610":"15ab1237","BondPageID":"0edf182a","CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage":"6edf17fd","PoolInvestPage~PoolPage~PortfolioPage":"0a872559","PoolInvestPage~PoolWithdrawPage":"dc8238f2","PoolInvestPage":"f26b0d03","PoolPage~PoolWithdrawPage":"e64e32f3","PoolWithdrawPage":"fd7eb1eb","HomePage~PortfolioPage":"d7c751e1","HomePage":"ea3d2290","PortfolioPage":"1cd5fb5f","PoolPage":"ae7db02b","SingleStakePage":"8991ab07","SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector":"74ce92c4","SunrisePage~TradePage~WalletConnectConnector":"dfb6c7fc","SunrisePage~TradePage":"94c1f3f8","SunrisePage":"f5e43f98","VexPolarPage":"260f8a7e","ClaimPage":"e647de10","CookiesPolicyPage":"1a475051","CreatePoolPage":"d4c9be7c","GetVeBalPage":"8619a848","TradePage":"737c0411","FaucetPage":"3e12ed8b","GnosisSafeConnector":"2b1600fb","MigratePoolPage":"4ce7ac99","PrivacyPolicyPage":"2bf66f5b","WalletConnectConnector~WalletLinkConnector":"5910b658","WalletConnectConnector":"24737ed0","WalletLinkConnector":"90d47f8b","SunrisesPage":"b9b5d53c","TallyConnector":"475cb2c8","TermsOfUsePage":"a377cd63","UnlockVeBalPage":"9531749c","VeBalPage":"0bd0b446","chunk-2d0cfad7":"1e2c5dff","chunk-2d0deb55":"8b2a825c","chunk-744a452f":"e6bb38c9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BondPage":1,"BondPageID":1,"CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage":1,"PoolInvestPage~PoolWithdrawPage":1,"PoolInvestPage":1,"PoolWithdrawPage":1,"HomePage~PortfolioPage":1,"HomePage":1,"PortfolioPage":1,"PoolPage":1,"SingleStakePage":1,"SunrisePage":1,"VexPolarPage":1,"ClaimPage":1,"CreatePoolPage":1,"GetVeBalPage":1,"TradePage":1,"MigratePoolPage":1,"SunrisesPage":1,"UnlockVeBalPage":1,"VeBalPage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"BondPage":"BondPage","BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610":"BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610","BondPageID":"BondPageID","CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage":"CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage","PoolInvestPage~PoolPage~PortfolioPage":"PoolInvestPage~PoolPage~PortfolioPage","PoolInvestPage~PoolWithdrawPage":"PoolInvestPage~PoolWithdrawPage","PoolInvestPage":"PoolInvestPage","PoolPage~PoolWithdrawPage":"PoolPage~PoolWithdrawPage","PoolWithdrawPage":"PoolWithdrawPage","HomePage~PortfolioPage":"HomePage~PortfolioPage","HomePage":"HomePage","PortfolioPage":"PortfolioPage","PoolPage":"PoolPage","SingleStakePage":"SingleStakePage","SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector":"SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector","SunrisePage~TradePage~WalletConnectConnector":"SunrisePage~TradePage~WalletConnectConnector","SunrisePage~TradePage":"SunrisePage~TradePage","SunrisePage":"SunrisePage","VexPolarPage":"VexPolarPage","ClaimPage":"ClaimPage","CookiesPolicyPage":"CookiesPolicyPage","CreatePoolPage":"CreatePoolPage","GetVeBalPage":"GetVeBalPage","TradePage":"TradePage","FaucetPage":"FaucetPage","GnosisSafeConnector":"GnosisSafeConnector","MigratePoolPage":"MigratePoolPage","PrivacyPolicyPage":"PrivacyPolicyPage","WalletConnectConnector~WalletLinkConnector":"WalletConnectConnector~WalletLinkConnector","WalletConnectConnector":"WalletConnectConnector","WalletLinkConnector":"WalletLinkConnector","SunrisesPage":"SunrisesPage","TallyConnector":"TallyConnector","TermsOfUsePage":"TermsOfUsePage","UnlockVeBalPage":"UnlockVeBalPage","VeBalPage":"VeBalPage"}[chunkId]||chunkId) + "." + {"BondPage":"e05a0a1f","BondPageID~HomePage~PoolInvestPage~PoolPage~PoolWithdrawPage~PortfolioPage~SingleStakePage~SunrisePa~d6319610":"31d6cfe0","BondPageID":"d765be92","CreatePoolPage~GetVeBalPage~PoolInvestPage~PoolWithdrawPage~TradePage":"b6430e70","PoolInvestPage~PoolPage~PortfolioPage":"31d6cfe0","PoolInvestPage~PoolWithdrawPage":"330dddd6","PoolInvestPage":"e7ef7e38","PoolPage~PoolWithdrawPage":"31d6cfe0","PoolWithdrawPage":"fb4d08fc","HomePage~PortfolioPage":"d188137d","HomePage":"eaa1ae73","PortfolioPage":"1272ffa7","PoolPage":"8efed76a","SingleStakePage":"e93f3fcd","SunrisePage~TradePage~WalletConnectConnector~WalletLinkConnector":"31d6cfe0","SunrisePage~TradePage~WalletConnectConnector":"31d6cfe0","SunrisePage~TradePage":"31d6cfe0","SunrisePage":"dc323527","VexPolarPage":"6229d0b3","ClaimPage":"8e29c1a8","CookiesPolicyPage":"31d6cfe0","CreatePoolPage":"44ce3132","GetVeBalPage":"d8d31405","TradePage":"ee4113c3","FaucetPage":"31d6cfe0","GnosisSafeConnector":"31d6cfe0","MigratePoolPage":"a16d2ca4","PrivacyPolicyPage":"31d6cfe0","WalletConnectConnector~WalletLinkConnector":"31d6cfe0","WalletConnectConnector":"31d6cfe0","WalletLinkConnector":"31d6cfe0","SunrisesPage":"411fb4f1","TallyConnector":"31d6cfe0","TermsOfUsePage":"31d6cfe0","UnlockVeBalPage":"43a7ab5b","VeBalPage":"b7024ebc","chunk-2d0cfad7":"31d6cfe0","chunk-2d0deb55":"31d6cfe0","chunk-744a452f":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
